// Gentle fade-up of page sections as they scroll into view.
// Content is only hidden once this script runs, so crawlers and no-JS visitors see everything.
let observer = null;

export const initReveal = () => {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (/ReactSnap|bot|crawl|spider|Lighthouse/i.test(navigator.userAgent || '')) return;
  const root = document.documentElement;
  root.classList.add('reveal-ready');
  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
  }
  const sections = Array.from(document.querySelectorAll('main section')).filter((el) => !el.parentElement.closest('section') && !el.classList.contains('is-visible'));
  sections.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) el.classList.add('is-visible');
    else observer.observe(el);
  });
};
